import { twMerge } from '@/lib/classname/twMerge'
import { BaseSkeleton } from '@/ui/skeleton/BaseSkeleton'
import { SELECT_FIELD_HEIGHT } from './select.styles'

export type SelectSkeletonProps = UiComponentProps<{
  withLabel?: boolean
}>

export function SelectSkeleton({
  withLabel = true,
  className,
  id,
  'data-testid': dataTestId,
}: SelectSkeletonProps) {
  return (
    <div
      id={id}
      data-testid={dataTestId}
      className={twMerge('flex w-full min-w-[15rem] flex-col gap-1', className)}
    >
      {withLabel && <BaseSkeleton className="mb-1 h-2 w-9 rounded-full" />}
      <BaseSkeleton className={twMerge('w-full rounded-sm', SELECT_FIELD_HEIGHT)} />
    </div>
  )
}
